// src/ExpertAchievements.jsx

import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const achievements = [
  { title: "💬 100+ Sessions Completed", description: "Awarded for hosting 100 successful sessions." },
  { title: "🌟 Top Rated Expert", description: "Maintained 4.9+ rating for over 3 months." },
  { title: "🚀 Growth Champion", description: "Achieved 2x month-on-month booking growth." },
];

const ExpertAchievements = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Achievements</h1>

      <div className="grid gap-4 md:grid-cols-2">
        {achievements.map((a, idx) => (
          <Card key={idx} className="bg-white shadow-sm border">
            <CardContent className="p-4">
              <p className="font-medium text-lg">{a.title}</p>
              <p className="text-sm text-gray-600">{a.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ExpertAchievements;
